import { render, staticRenderFns } from "./noticeArea.vue?vue&type=template&id=416aa3ac&scoped=true"
import script from "./noticeArea.vue?vue&type=script&lang=js"
export * from "./noticeArea.vue?vue&type=script&lang=js"
import style0 from "./noticeArea.vue?vue&type=style&index=0&id=416aa3ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416aa3ac",
  null
  
)

export default component.exports